<template>
  <DialogTemplate :show-controls="true" class="dialog" icon-header="locked">
    <template #header> {{ title }} </template>
    <p>{{ description }}</p>
    <template #footer>
      <div class="actions">
        <ButtonBase
          rounded
          theme="secondary"
          variant="tonal"
          stroke="n"
          :to="`${runtimeConfig.public.eva1Url}/premium`"
        >
          {{ $t('locked.popin.button.premium') }}
        </ButtonBase>
      </div>
    </template>
  </DialogTemplate>
</template>
<script lang="ts" setup>
interface Props {
  title: string;
  description: string;
}
defineProps({
  title: null,
  description: null
});
const runtimeConfig = useRuntimeConfig();
</script>
<style lang="scss" scoped>
.actions {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
p {
  @include font('n', 400);
}
</style>
